"use client";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import { Home, Map, Assignment } from "@mui/icons-material";
import Link from "next/link";
import UserMenu from "@/components/editor/UserMenu";

export default function AppNavBar() {
  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{ bgcolor: "#23252b", color: "#fff" }}
    >
      <Toolbar sx={{ justifyContent: "space-between", minHeight: 56 }}>
        <Box sx={{ width: 56, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
          <IconButton component={Link} href="/" aria-label="Home" sx={{ color: "primary.main" }}>
            <Home fontSize="large" />
          </IconButton>
        </Box>

        <Box sx={{ display: "flex", gap: 1 }}>
          <Button
            component={Link}
            href="/maps"
            startIcon={<Map />}
            sx={{
              color: "#fff",
              textTransform: "none",
              minWidth: 160,
              justifyContent: "flex-start",
              "&:hover": { bgcolor: "rgba(255,255,255,0.08)" },
            }}
          >
            Maps
          </Button>
          <Button
            component={Link}
            href="/actions"
            startIcon={<Assignment />}
            sx={{
              color: "#fff",
              textTransform: "none",
              minWidth: 160,
              justifyContent: "flex-start",
              "&:hover": { bgcolor: "rgba(255,255,255,0.08)" },
            }}
          >
            Action Items
          </Button>
        </Box>

        <Box sx={{ width: 56, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
          <UserMenu />
        </Box>
      </Toolbar>
    </AppBar>
  );
}
